export const MPUSize = {
  width: 300,
  height: 250,
};
